import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function isReadonly() {
  try {
    const raw = sessionStorage.getItem('user_info')
    if (!raw) return false
    const info = JSON.parse(raw)
    return Number(info.is_readonly) === 1
  } catch (e) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js